module.exports = "app-unassigned-tests {\n    padding-right: 0;\n}\n\n.container-fluid {\n    height: calc(100% - 3.5em);\n}\n\n.drag-over-border {\n    border: thick solid red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main